import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccessGroupService } from './../access-group.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';

declare var crs: any;

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss']
})
export class AddressesComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  addresses: any[] = [];
  filteredAddresses: any[] = [];
  showModal = false;
  isNewAddress = true;
  loading = false;

  // Search, sort, pagination (client-side — API has no server-side support)
  searchTerm = '';
  sortColumn = 'name';
  sortDirection: 'asc' | 'desc' = 'asc';
  currentPage = 1;
  perPage = 10;

  city: string;
  state: string;
  country: string;
  postal_code: string;
  address_name: string;
  org_name: string;
  address_line1: string;
  address_line2: string;
  address_first_name: string;
  address_last_name: string;
  address_nmbr;
  update_city: string;
  update_state: string;
  update_email: string;
  update_org: string;
  update_country: string;
  update_postal_code: string;
  update_address_name: string;
  update_address_first_name: string;
  update_address_last_name: string;
  update_address_email: string;
  update_address_line1: string;
  update_address_nmbr;
  update_address_line2: string;
  address_id: number;

  constructor(
    public accessgroup: AccessGroupService,
    public router: Router,
    public http: HttpClient
  ) {}

  ngOnInit() {
    this.loadAddresses();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadAddresses() {
    this.loading = true;
    this.http.get(`${environment.assessment_admin}api/v1/addresses`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.loading = false;
          if (data['errors']) {
            Swal.fire('Oops!', data['errors'], 'error');
          } else {
            this.addresses = data['addresses'] || [];
            this.filterAddresses();
          }
        },
        (error) => {
          this.loading = false;
          Swal.fire('Oops!', 'Failed to load addresses.', 'error');
        }
      );
  }

  // ── Client-side search ──

  filterAddresses(): void {
    let result = [...this.addresses];

    if (this.searchTerm.trim()) {
      const term = this.searchTerm.toLowerCase();
      result = result.filter(a =>
        (a.name || '').toLowerCase().includes(term) ||
        (a.first_name || '').toLowerCase().includes(term) ||
        (a.last_name || '').toLowerCase().includes(term) ||
        (a.city || '').toLowerCase().includes(term) ||
        (a.state || '').toLowerCase().includes(term) ||
        (a.country || '').toLowerCase().includes(term) ||
        (a.organization_name || '').toLowerCase().includes(term)
      );
    }

    // Sort
    const dir = this.sortDirection === 'asc' ? 1 : -1;
    result.sort((a, b) => {
      const valA = (a[this.sortColumn] || '').toLowerCase();
      const valB = (b[this.sortColumn] || '').toLowerCase();
      return valA.localeCompare(valB) * dir;
    });

    this.filteredAddresses = result;
    this.currentPage = 1;
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.filterAddresses();
  }

  // ── Client-side sort ──

  toggleSort(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.filterAddresses();
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) return 'fa-sort';
    return this.sortDirection === 'asc' ? 'fa-sort-alpha-asc' : 'fa-sort-alpha-desc';
  }

  // ── Client-side pagination ──

  get paginatedAddresses(): any[] {
    const start = (this.currentPage - 1) * this.perPage;
    return this.filteredAddresses.slice(start, start + this.perPage);
  }

  get pageNumbers(): number[] {
    const total = Math.ceil(this.filteredAddresses.length / this.perPage);
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  public open() {
    this.isNewAddress = true;
    this.showModal = true;
    setTimeout(() => crs?.init(), 100);
  }

  public update(i, id) {
    this.address_id = id;
    this.isNewAddress = false;
    this.showModal = true;
    this.update_address_name = this.addresses[i].name;
    this.update_org = this.addresses[i].organization_name;
    this.update_address_first_name = this.addresses[i].first_name;
    this.update_address_last_name = this.addresses[i].last_name;
    this.update_address_email = this.addresses[i].email;
    this.update_address_line1 = this.addresses[i].address_line1;
    this.update_address_line2 = this.addresses[i].address_line2;
    this.update_address_nmbr = this.addresses[i].phone;
    this.update_city = this.addresses[i].city;
    this.update_state = this.addresses[i].state;
    this.update_country = this.addresses[i].country;
    this.update_postal_code = this.addresses[i].postal_code;
    setTimeout(() => crs?.init(), 100);
    setTimeout(() => {
      $('#update_country').val(this.update_country).trigger('change');
      $('#update_state').val(this.update_state);
    }, 1000);
  }

  public addAddress() {
    const Data = {
      name: this.address_name,
      organization_name: this.org_name,
      first_name: this.address_first_name,
      last_name: this.address_last_name,
      email: this.update_email,
      address_line1: this.address_line1,
      address_line2: this.address_line2,
      phone: this.address_nmbr,
      city: this.city,
      state: this.state,
      country: this.country,
      postal_code: this.postal_code
    };
    const checkValue = () => {
      return (this.address_name && this.address_line1 && this.address_nmbr?.length >= 10 &&
        this.address_first_name && this.address_last_name && this.update_email &&
        this.city && this.country && this.postal_code && this.state);
    };
    if (checkValue()) {
      this.http.post(`${environment.assessment_admin}api/v1/addresses`, Data)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res) => {
            Swal.fire('Nice!', 'Your new address has been added!', 'success');
            this.showModal = false;
            this.loadAddresses();
          },
          (err) => {
            Swal.fire('Oops!', err?.error?.errors || 'Failed to add address.', 'error');
          }
        );
    }
  }

  public updateAddress() {
    const Data = {
      name: this.update_address_name,
      organization_name: this.update_org,
      first_name: this.update_address_first_name,
      last_name: this.update_address_last_name,
      email: this.update_address_email,
      address_line1: this.update_address_line1,
      address_line2: this.update_address_line2,
      phone: this.update_address_nmbr,
      city: this.update_city,
      state: this.update_state,
      country: this.update_country,
      postal_code: this.update_postal_code
    };
    const checkValue = () => {
      return (this.update_address_line1 && this.update_address_first_name &&
        this.update_address_last_name && this.update_address_email &&
        this.update_address_nmbr?.length >= 10 && this.update_address_name &&
        this.update_city && this.update_country && this.update_state && this.update_postal_code);
    };
    if (checkValue()) {
      this.http.put(`${environment.assessment_admin}api/v1/addresses/${this.address_id}`, Data)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res) => {
            Swal.fire('Nice!', 'Your address has been updated!', 'success');
            this.showModal = false;
            this.loadAddresses();
          },
          (err) => {
            Swal.fire('Oops!', err?.error?.errors || 'Failed to update address.', 'error');
          }
        );
    }
  }

  public deleteAddress(index, id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This address will be permanently deleted.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.http.delete(`${environment.assessment_admin}api/v1/addresses/${id}`)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (res) => {
              Swal.fire('Nice!', 'Your address has been deleted!', 'success');
              this.loadAddresses();
            },
            (err) => {
              Swal.fire('Oops!', err?.error?.errors || 'Failed to delete address.', 'error');
            }
          );
      }
    });
  }

  public notNumber(evt) {
    if ((evt.which < 48 || evt.which > 57) && (evt.which !== 43)) {
      evt.preventDefault();
    }
  }
}
